<script setup lang="ts"></script>
<template>
  <td class="border-gray border py-4 pl-6 pr-2 font-semibold">
    <slot />
  </td>
</template>
